export default __webpack_public_path__ + "static/media/go-6.4c88fbf9.svg";